<div class="is-relative">
    <form [formGroup]="form" class="content-type-form" isavFieldIndex>
        <isav-field-index></isav-field-index>

        <isav-text-input
            label="1. Full name"
            formControlName="fullName"
            [mandatory]="true"
            tooltipKey="Person:fullName"
        ></isav-text-input>
        <isav-text-input
            label="2. Email"
            formControlName="email"
            [mandatory]="true"
            tooltipKey="Person:email"
        ></isav-text-input>
        <isav-password-input
            label="3. Password"
            formControlName="password"
            [mandatory]="true"
            tooltipKey="Person:password"
        ></isav-password-input>
        <isav-text-input
            label="4. Phone"
            formControlName="phone"
            [mandatory]="true"
            tooltipKey="Person:phone"
        ></isav-text-input>
        <isav-taxonomy-select-input
            label="5. User profile"
            formControlName="userProfileType"
            taxonomy="UserProfileType"
            placeholder="Select profile type"
            [mandatory]="true"
            tooltipKey="Person:userProfileType"
        ></isav-taxonomy-select-input>
        <isav-content-editor
            label="6. Description"
            [mandatory]="true"
            formControlName="description"
            tooltipKey="Person:description"
        ></isav-content-editor>
        <isav-many-input
            label="7. Links to CV"
            addLabel="Add another link to CV"
            removeLabel="Remove link"
            formControlName="linksToCV"
            tooltipKey="Person:linksToCV"
        >
            <isav-link-input
                *isavManyInputControl="let control; let position = position"
                [formControl]="control"
                [label]="'7.' + position + '. Link'"
            ></isav-link-input>
        </isav-many-input>
        <isav-taxonomy-select-input
            label="8. Organisation"
            formControlName="organisation"
            [mandatory]="true"
            taxonomy="Organisation"
            placeholder="Select organisation"
            tooltipKey="Person:organisation"
        ></isav-taxonomy-select-input>
        <isav-link-input
            label="9. Other organisation link and name"
            formControlName="organisationLink"
            tooltipKey="Person:organisationLink"
        ></isav-link-input>
        <isav-text-input
            label="10. Address"
            formControlName="address"
            tooltipKey="Person:address"
        ></isav-text-input>
        <isav-text-input
            label="11. Zipcode"
            formControlName="zipcode"
            tooltipKey="Person:zipcode"
        ></isav-text-input>
        <isav-text-input
            label="12. City"
            formControlName="city"
            tooltipKey="Person:city"
        ></isav-text-input>
        <isav-taxonomy-select-input
            label="13. Country"
            formControlName="country"
            taxonomy="Country"
            placeholder="Select country"
            [mandatory]="true"
            tooltipKey="Person:country"
        ></isav-taxonomy-select-input>
        <isav-coordinates-input
            label="14. Location"
            formControlName="location"
            [mandatory]="true"
            tooltipKey="Person:location"
            mapType="WorldStreetMap"
        ></isav-coordinates-input>
        <isav-taxonomy-checkbox-list-input
            label="15. Expertises"
            formControlName="expertises"
            taxonomy="Topic"
            [mandatory]="true"
            multiple="true"
            tooltipKey="Person:expertises"
        ></isav-taxonomy-checkbox-list-input>
        <isav-taxonomy-checkbox-list-input
            label="16. Field of interests"
            formControlName="fieldOfInterests"
            taxonomy="Topic"
            multiple="true"
            tooltipKey="Person:fieldOfInterests"
        ></isav-taxonomy-checkbox-list-input>
        <div class="field is-horizontal mb-2">
            <div class="field-label field-label-tooltip">
                <isav-tooltip-display
                    tooltipKey="Person:receivingNewsletter"
                ></isav-tooltip-display>
            </div>
            <div class="field-body mt-1">
                <label class="checkbox">
                    <input formControlName="receivingNewsletter" type="checkbox" />
                    Do you want to receive <strong>monthly</strong> newsletter based on your field
                    of interests?
                </label>
            </div>
        </div>
        <div class="field is-horizontal mb-2">
            <div class="field-label field-label-tooltip">
                <isav-tooltip-display tooltipKey="Person:gpdrConsented"></isav-tooltip-display>
            </div>
            <div class="field-body mt-1">
                <label class="checkbox">
                    <input formControlName="gpdrConsented" type="checkbox" />
                    I agree to share my contact data with external partners
                </label>
            </div>
        </div>
        <isav-image-form
            label="17. Profile image"
            formControlName="profileImage"
            [mandatory]="true"
            tooltipKey="Person:profileImage"
            [editable]="false"
        ></isav-image-form>
        <div class="buttons is-right">
            <ng-content></ng-content>
            <button
                type="button"
                isavBtn
                color="success"
                [disabled]="!form.valid"
                (click)="onSave()"
            >
                Register
            </button>
        </div>
    </form>
</div>
